import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';

const API_SLUG = 'ImportacionesLog';

export interface ImportacionesLogCabecera {
	año: number;
	periodo: number;
	idTipo: string;
}

export interface ImportacionesLogDetalle {
	idImportacion: number;
}

export class ImportacionesLogAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarCabeceras(data:ImportacionesLogCabecera): AxiosPromise<any> {
		return this.cliente.post(data, `/ListarCabeceras`);
	}

	ListarDetalle(data:ImportacionesLogDetalle): AxiosPromise<any> {
		return this.cliente.post(data, `/ListarDetalle`);
	}

	ListarUltimaImportacion() : AxiosPromise<any>{
		return this.cliente.get('/ListarUltimaImportacion');
	}
	
}